import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const TwoDotSixteenDotThree = () => {
  return (
    <ChangelogInstance version="2.16.4" date="2023-06-29">
      <li>
        Fixed trade offer automation, friend request monitoring. 
      </li>
      <li>
        Removed notification option for new items and friend requests.
      </li>
      <li>
        Adjusted styling.
      </li>
    </ChangelogInstance>
  );
}

export default TwoDotSixteenDotThree;